const useMessageError = () => {
  const getMessageError = (error) => {
    return error.graphQLErrors.length > 0 ? error.graphQLErrors[0].message : error.message;
  };

  return { getMessageError };
};

export default useMessageError;
